export default "__VITE_ASSET__637a67d0__"